import * as React from "react";
import { forwardRef } from "react";
const SvgNorthWest = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M3.375 10.875H4.875V5.9325L13.5675 14.625L14.625 13.5675L5.9325 4.875H10.875V3.375H3.375V10.875Z", fill: "#F7F8FA" }));
const ForwardRef = forwardRef(SvgNorthWest);
export { ForwardRef as ReactComponent };
